import React from 'react';
import { Button } from '@/components/ui/button';
import { FileText, Loader2 } from 'lucide-react';
import { useReportPdfExport } from '@/hooks/useReportPdfExport';

interface ExportReportPdfButtonProps {
  targetRef: React.RefObject<HTMLElement>;
  title: string;
  subtitle?: string;
  filenameSlug?: string;
  disabled?: boolean;
  className?: string;
}

export const ExportReportPdfButton: React.FC<ExportReportPdfButtonProps> = ({
  targetRef,
  title,
  subtitle,
  filenameSlug,
  disabled = false,
  className,
}) => {
  const { exportElementToPdf, isExporting } = useReportPdfExport();

  return (
    <Button
      variant="outline"
      size="sm"
      className={className}
      disabled={disabled || isExporting}
      data-pdf-hide
      onClick={() => exportElementToPdf(targetRef.current, { title, subtitle, filenameSlug })}
    >
      {isExporting ? (
        <>
          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
          Gerando PDF...
        </>
      ) : (
        <>
          <FileText className="h-4 w-4 mr-2" />
          Exportar PDF
        </>
      )}
    </Button>
  );
};
